import { render } from "./LilaMatrixSupportRequest.vue?vue&type=template&id=f37ad5a8"
import script from "./LilaMatrixSupportRequest.vue?vue&type=script&lang=js"
export * from "./LilaMatrixSupportRequest.vue?vue&type=script&lang=js"

import "./LilaMatrixSupportRequest.vue?vue&type=style&index=0&id=f37ad5a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__